<template>
	<div><div id="heartData"></div></div>
</template>

<script>
export default {
	data() {
		return {
			// websock: null,
			heartList: []
		};
	},
	created() {
		this.initWebSocket();
	},
	// destroyed() {
	// 	this.websock.close() //离开路由之后断开websocket连接
	// },
	mounted() {
		window.console.log(this.heartList);
		this.getEcharts();
	},
	methods: {
		getEcharts() {
			var that = this;
			var heartData = that.$echarts.init(document.getElementById('heartData'));
			var xAxisData = [];
			var yAxisData = [];
			for (var i = 500; i > 0; i--) {
				xAxisData.push(i + '秒前');
			}
			for (i = 1; i < 501; i++) {
				if (that.heartList.length > 0) {
					that.heartList.map(val => {
						yAxisData.push(val);
					});
				} else {
					yAxisData.push(0);
				}
			}
			var heartDataOption = {
				animation: false,
				title: {
					text: '心率（次/分钟）'
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'cross'
					}
				},
				grid: {
					left: 50,
					right: 15
				},
				xAxis: {
					boundaryGap: false,
					data: xAxisData
				},
				yAxis: {
					boundaryGap: false
				},
				series: {
					symbol: 'none',
					/*去掉小圆点*/
					name: '当前心率值',
					type: 'line',
					itemStyle: {
						normal: {
							lineStyle: {
								width: 2, //折线宽度
								color: '#EB5396' //折线颜色
							}
						}
					},
					data: yAxisData
				}
			};
			heartData.setOption(heartDataOption);
			window.onresize = heartData.resize();
			setInterval(function() {
				if (that.heartList.length > 0) {
					that.heartList.map(val => {
						yAxisData.push(val);
					});
				} else {
					yAxisData.push(0);
				}
				yAxisData.shift();
				heartData.setOption(heartDataOption);
				window.onresize = heartData.resize();
			}, 150);
		},
		initWebSocket() {
			//初始化weosocket
			const wsuri = 'ws://121.46.26.109:8060/webSocketServer';
			var websock = new WebSocket(wsuri);
			window.console.log(11);
			// this.heartList=[0,2,1,21,11,20,10,20]
			websock.onmessage = this.websocketonmessage;
			websock.onerror = this.websocketonerror;
		},
		websocketonerror() {
			//连接建立失败重连
			this.initWebSocket();
		},
		websocketonmessage(e) {
			//数据接收
			window.console.log(e);
			// const redata = JSON.parse(e.data);
		}
	}
};
</script>

<style scoped="scoped">
#heartData {
	height: 300px;
}
</style>
